import { Language, useSiteSettingsContext } from '@core/shared';
import { OptionsApi } from '@core/swagger-client';
import { useSuspenseQuery } from '@tanstack/react-query';
import { ReactNode, useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { defaultResources, resources } from './resources';
import { usei18n } from './usei18n';

export function I18nProvider({ children }: Readonly<{ children: ReactNode }>) {
    const defaultLanguage = useSiteSettingsContext().defaultLanguage;
    const [lng, setLng] = useState(defaultLanguage);
    const { data: patch } = useSuspenseQuery(OptionsApi.translation.get(lng, { staleTime: 600_000 }));
    resources[lng].translation = { ...defaultResources[lng].translation, ...patch };

    const i18n = usei18n(defaultLanguage);
    // In an effect, not during render: i18next is one instance for the whole server process, so a listener added
    // per render was never removed and kept every request's tree alive. Effects do not run on the server.
    useEffect(() => {
        const onLanguageChanged = (lng: string) => setLng(lng as Language);
        i18n.on('languageChanged', onLanguageChanged);
        return () => i18n.off('languageChanged', onLanguageChanged);
    }, [i18n]);

    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
